module.exports = __webpack_public_path__ + "static/img/home_version_logo.9dae24bd.png";